
import React, {useState, useEffect, useMemo} from 'react';
import {
    Button,
    Card,Table,
    CardBody,
  } from "reactstrap";
  import ReactTable from "components/ReactTable/ReactTable.js";
  import CreateVInfo from './CreateVInfo'
  import { useSelector } from 'react-redux'
  import Select from "react-select";
  import jwtDecode from "jwt-decode";
  
  function Mylistings(props) {
    const [user, setUser] = React.useState({fn : "", cn : "", tuid : ""})
    const catlist  = useSelector(state => state.featureStore.featureData).map(x => {
        return {
              label :x.categoryName.en  , value : x.categoryCode, 
              labelfr : x.categoryName.fr, labelar : x.categoryName.ar,
              features : x.features, unit : x.unit
            }
          })


    const [vehicle , setVehicle ] = useState({
        vid : "",
        luid : "",
        tluid: "",
        tuid : "",
        listingtype : "",
        categoryCode : "", 
        category : {en : "", fr : "", ar : ""},
        bid : "",
        blogo : "",
        bname :   {en : "", fr : "", ar : ""},
        mname :  {en : "", fr : "", ar : ""},
        modelyear : {value : "", label :""},
        notes : "",
        vtypeCode : "",
        vtname : {en : "", fr : "", ar : ""},
        features: [{featureCode : "", en : "", fr : "", ar : "", unit : "", rangeid : "" , rangevalueL : "" , rangevalueH: ""}],
        insurence : true,
        intcolor  : "",
        extcolor : "",
        approxmiles : "",
        daily : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fdaily : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        weekly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fweekly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        monthly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fmonthly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
      })
    const [showProcessing , setShowProcessing] = useState(false)
    const [mylist , setMylist] = useState([])
    const [infom, setInfom] = useState(false)
    const [featuresList, setFeatureslist] = useState([])
    const [ucount, setUcount] = useState(0)  
    
    
    const remListing = (tluid, tuid) => {
          props.swal({
            title: "Are you sure?",
            text: "Are you sure that you want to delete listing at :" + tluid,
            icon: "warning",
            dangerMode: true,
          })
          .then(willDelete => {
            if (willDelete) {
              setShowProcessing(true)    
                props.API.get(`ten/remlist/${tluid}/${tuid}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                mylisting()                   
                setShowProcessing(false)      
                }).catch(function (error) {
                    setShowProcessing(false)
                    console.log(error)
                    if(error.response.status === 401){
                      props.swal("Unauthorized, please login again.").then(t => {
                          props.history.push(`/auth/login`)
                      })   
                    }else{
                      props.swal("Error")
                    }
                    
                  }) 
                  
                }
          });
          return
         
        
    }

    const updatecounter = (tluid) => {
      setShowProcessing(true)
      props.API.get(`tenant/luccvt` , {headers: {"arixauth" : localStorage.getItem("arixauth")}})
      .then(res => {
        setShowProcessing(false)
        setUcount(res.data.tdu)
      }).catch(x => {
        setShowProcessing(false)
        props.swal(x.response.data.message)
      })    
    }

    const errorhandler = (error) => {
      try{
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }else{
          props.swal(error.response.data.message)
        }
      } catch(e){
        props.swal("error processing request at this time, please contact support.")
      } 
    
    }

    const mylisting = () => {
        setShowProcessing(true)
        props?.user?.tuid && props.API.get(`tenant/mylisting/${props.user.tuid}`,{headers : {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
          
          let data = res.data.map((aa,k) =>{
            
            return {
              id: k,
              ac : aa,
              ltype : (
                <div  >
                         <Select 
                         menuPortalTarget={document.body}
                         styles={{menuPortal : base =>({...base, zIndex : 9999})  }} options = {[{value : "0", label: "Premium"},{value : "1", label: "Featured"},{value : "2", label: "Delisted"}]}
                                onChange={n => {
                                      if(!checklistings(n, res.data)){
                                        let obj = data.find((o) => o.id === k);
                                        obj.ac.listingType = n.label
                                        setVehicle({...obj.ac})  
                                        updlisting(obj.ac)
                                      }else{
                                        alert("Sorry you are aceeding limits..")
                                      }
                                    
                                    }}
                                    
                              value={{value : "0" , label : aa.listingType}}
                              />
                </div>
              ),
              actions: (
                  // we've added some custom button actions
                  <div className="actions-right">
                      <div></div>
                       <Button
                      onClick={() => {
                        let obj = data.find((o) => o.id === k);
                         //setVehicle({...obj.ac})
                         remListing(obj.ac.tluid , obj.ac.tuid)
                        
                      }}
                      color="danger"
                      size="sm"
                      className="btn-icon btn-link remove"
                      style={{padding : 0, margin : 0}}
                    >
                     <i className="fa fa-remove" aria-hidden="true"></i>
                    </Button>    {' '}
                    <Button
                      onClick={() => {
                        
                        let obj = data.find((o) => o.id === k);
                        setVehicle({...obj.ac})
                        
                          setFeatureslist(catlist.find(e => e.value === obj.ac.categoryCode)?.features?.map(t => {
                           return {
                           ...t, value : t.featureCode, label: t.en, labelfr: t.fr, labelar : t.ar , unit : t.unit
                           }
                       }));  
                       setInfom(true)
                      }}
                      color="info"
                      style={{padding : 0, margin : 0}}
                      size="sm"
                      className="btn-icon btn-link edit"
                    >
                     <i className="fa fa-info" aria-hidden="true"></i>
                    </Button>    {' '}

                    <Button
                      onClick={() => {
                        let obj = data.find((o) => o.id === k);
                        setVehicle({...obj.ac})
                       
                        updlisting(obj.ac)
                       
                      }}
                      color="info"
                      size="sm"
                      style={{padding : 0, margin : 0 , fontSize : "0.5rem"}}
                      className="btn-icon btn-link edit"
                    >
                     <i className="fa fa-refresh" aria-hidden="true"></i>
                    </Button>    {' '}
                      
                  </div>
                ),
               }
           }
       )
       setMylist(data)
          setShowProcessing(false)             
        }).catch(function (error) {
          setShowProcessing(false)
          
          errorhandler(error)
          //props.basicAlert("Error fetching Vehicle Type data")
        }) 
  
        props?.user?.tuid && props.API.get(`tenant/lc/${props.user.tuid}`,{headers : {"arixauth" : localStorage.getItem("arixauth")}})
        .then(t => {
          
          setUcount(t.data.updats)
        })
        setShowProcessing(false)
        
      } 

    const showVehicle = () => {
        return (
              <Table style={{fontSize : "0.8rem"}}>
                <thead>
                    <tr>
                  <th></th>
                  <th>Feature</th>
                  <th style={{textAlign : "center"}}>Value</th>
                  {/** <th style={{textAlign : "center"}}>Max</th> */}
                  </tr>
                </thead>
                <tbody>
                  {
                     vehicle.features.map((x , key) => {
                      if(x.featureCode !== ""){
                        return (
                          <tr key={key}>
                            <td><img alt="..." width={"30px"} src={`${x.ficon}`} style={{ cursor : "pointer"}} /> </td>
                            <td>{x.en}</td>
                            <td style={{textAlign : "center"}}>{x.rangevalueL}</td>
                         {/**   <td style={{textAlign : "center"}}>{x.rangevalueH}</td>*/} 
                        
                          </tr>
                        )  
                      }
                      })
                  }
                 
                </tbody>
              </Table>
         
        )
      }

    const updlisting = (obj) => {
        setShowProcessing(true)
        props.API.get(`tenant/luccvt` , {headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
           console.log(res.data.message)
           if(res.data.message){
            props.API.post(`tenant/updlvt`, {vehicle : obj},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
              setShowProcessing(false)
              props.swal({
                title: "Listing Updated",
                text: "Listing Updated.",
                icon: "success",
                dangerMode: true,
              })
                  setUcount(res.data.tdu)
                 mylisting()
              }).catch(function (error) {
                setShowProcessing(false)   
                try{
               
                  console.log(error)
                  props.swal({
                    title: "Error",
                    text: error.response.data.message,
                    icon: "warning",
                    dangerMode: true,
                  })
                }catch(e){
                  props.swal({
                    title: "Error",
                    text: "Please relog and try again.",
                    icon: "warning",
                    dangerMode: true,
                  })
                }
              })
           }else{
            props.swal(`Listing update limit exceeded, please check listing page.`)
            setShowProcessing(false)
          }})

        
    }

    useEffect(() => {
      setUser(jwtDecode(localStorage.getItem('arixauth')))
     // jwtDecode(localStorage.getItem('arixauth'))?.tuid && updatecounter()
      jwtDecode(localStorage.getItem('arixauth'))?.tuid && mylisting()
    }, [])

    const checklistings = (label, data) => {
      
      let count = data.filter(j => j.listingType === label.label)
      if(label.label === "Featured") {
        return Number(count.length) >= Number(props.user.fla)
        
      }else if (label.label === "Premium") {
        return Number(count.length) >= Number(props.user.pla)
         
      }else if (label.label === "Delisted") {
        
        return false
         
      }
      
      
    }

    return (
        <div className="content">
            <CreateVInfo vehicle={vehicle} setInfom={setInfom} infom={infom} user={props.user} showVehicle={showVehicle}/>
            <h6>My Listings <span style={{float : "right"}}>
            <i className="fa fa-refresh" aria-hidden="true" style={{float : "right", cursor : "pointer", marginTop : 2}} onClick={f => {mylisting()}}/></span></h6>    
            {showProcessing && props.Spin } 
            <Card>
            <CardBody >
            <p>Allowed Update Limit: <b>Listing x 2</b> / Day 
            <span style={{float : "right"}}>{ucount} / <b> {mylist.length * Number(2)}</b> Day</span>   </p> 
            
                  <ReactTable 
                    data= {mylist}
                    columns={[
                      {
                        Header: "ListID",
                        accessor: d =>  d.ac.luid,
                      },
                      {
                          Header: "Img",
                          accessor: d =>  <center><img alt="..." width={"40px"} src={`${d.ac.blogo}`} style={{ cursor : "pointer"}} /> </center>,
                        },
                        {
                          Header: "C.Name",
                          accessor: d =>  d.ac.category.en + " " + d.ac.category.ar ,
                        },
                      
                      {
                        Header: "Brand",
                        accessor: d => d.ac.bname.en + " " + d.ac.bname.ar,
                      },
                      {
                          Header: "Model",
                          accessor: d =>  d.ac.mname.en + " " + d.ac.mname.ar,
                        },
                        {
                            Header: "Year",
                            accessor: d =>  d.ac.modelyear.label ,
                          },
                          {
                            Header: "Type",
                            accessor: d =>  d.ac.vtname.en ,
                          },
                          {
                            Header: "Specs",
                            accessor: d =>  d.ac.notes ,
                          },
                          {
                            Header: "Listed",
                            accessor: d =>  d.ltype ,
                          },

                    {
                            Header: "Daily",
                            accessor: d =>  <span>{d.ac.daily.amt} /  <span style={{color: "green"}}>{d.ac.fdaily.amt}</span></span>,
                    },
                      {
                        Header: "Actions",
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                      },
                    ]}
                    /*
                        You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                      */
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
             
            </Card>
        </div>
    );
}

export default Mylistings;